import LiquiditySummaryToolbar from 'widgets/liquiditySummary/toolbar/LiquiditySummaryToolbar';
import React from 'react';
import { WidgetLegend } from 'widgets/WidgetLegend/WidgetLegend';
import { LiquiditySummaryConfiguration } from 'widgets/liquiditySummary/store/configuration/LiquiditySummaryConfiguration';
import Legend from 'utils/components/Legend/Legend';
import { leavesTooltip } from 'widgets/liquiditySummary/help/liquiditySummaryLegendTootip';
import { useLiquiditySummaryConfigSlice } from 'widgets/liquiditySummary/store/configuration/configSlice';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { GridApi } from '@instinet-analytics/semantic-ui-components';

export interface LiquiditySummaryGridHeaderProps {
    orderLeaves: string;
    haveData: boolean;
    gridApi?: GridApi;
}

export function LiquiditySummaryGridHeader(
    props: LiquiditySummaryGridHeaderProps
) {
    const { haveData, orderLeaves, gridApi } = props;
    const { config } = useLiquiditySummaryConfigSlice();
    const { hideGridOrderLeavesLegend } = config;
    const { hasValidSelection } = useWidgetPortfolioSelectionStatus();

    return (
        <WidgetToolbarShowHidePanel
            mustShow={!hasValidSelection || !hideGridOrderLeavesLegend}
        >
            <LiquiditySummaryToolbar haveData={haveData} gridApi={gridApi}>
                <div className="grid-legend-toolbar toolbar">
                    <div>
                        <WidgetLegend<LiquiditySummaryConfiguration> hideLegendPropertyName="hideGridOrderLeavesLegend">
                            <Legend
                                className="order-leaves grid-legend"
                                value={orderLeaves}
                                label="Order leaves"
                                tooltip={leavesTooltip}
                            />
                        </WidgetLegend>
                    </div>
                </div>
            </LiquiditySummaryToolbar>
        </WidgetToolbarShowHidePanel>
    );
}
